import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'app-modal-terminos',
  templateUrl: './modal-terminos.component.html',
  styleUrls: ['./modal-terminos.component.css']
})
export class ModalTerminosComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
  }
   onClick(){
     this.accountService.aceptar();
     this.activeModal.dismiss('Cross click');
   }

}
